module.exports = __webpack_public_path__ + "static/img/5.11e27819.gif";